"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _material = require("@mui/material");
var _CategoryPanel = _interopRequireDefault(require("./CategoryPanel"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
/**
 * Desktop Navigation - Main Menu List, used in Navigation Component
 *
 * @visibleName Desktop Navigation - Main Menu List
 * @author [Jeff Stevens](mailto:jeffrey.stevens@pheaa.org)
*/
const CategoryMenuList = props => {
  const {
    ad,
    customTheme = {},
    items,
    testId,
    ...rest
  } = props;
  return /*#__PURE__*/_react.default.createElement(_material.Box, {
    "data-testid": testId,
    sx: {
      alignItems: "center",
      display: "flex",
      justifyContent: "flex-start"
    }
  }, items.map((item, i) => {
    return /*#__PURE__*/_react.default.createElement(_CategoryPanel.default, _extends({
      ad: ad,
      customTheme: customTheme,
      key: `menu-button_${i}]`,
      buttonId: `navigation__menu-button-id_${i}`,
      menuId: `navigation__menu-id_${i}`,
      item: item
    }, rest));
  }));
};
CategoryMenuList.propTypes = {
  /** Object describing advertisement properties */
  ad: _propTypes.default.object,
  /** Theme injection object (Default Value: {}) */
  customTheme: _propTypes.default.object,
  /** Array of Menu Labels and Values */
  items: _propTypes.default.arrayOf(_propTypes.default.shape({
    /** Visible Label for menu item */
    label: _propTypes.default.string,
    /** Unique string used in state */
    value: _propTypes.default.string
  })).isRequired,
  /** @ignore */
  testId: _propTypes.default.string
};
var _default = exports.default = CategoryMenuList;